module.exports = __webpack_public_path__ + "media/images/icon-left-short-f615eb1aa4a942d1b7f818d97e6a7104.svg";